export default __webpack_public_path__ + "static/media/gallery9.9217e594.jpg";